import React from 'react'
import { useDispatch } from 'react-redux';
import { changePayments, changePoint } from '../redux/payPoints';
import { GET_REQUEST } from '../../../../HooksApi/useApi';
import UseGetData from '../../../../HookAxios/getdata';
const HookPayPoints = () => {
    const dispatch = useDispatch()
    const [valueMethod, setValueMethod] = React.useState('');
    const ChangeValueMethod = (event, index) => {
        setValueMethod(event.target.value);
        dispatch(changePayments(JSON.parse(event.target.value)))
    };
    const [valuePoints, setValuePoints] = React.useState('');
    const ChangeValuePoints = (event, index) => {
        setValuePoints(event.target.value);
        dispatch(changePoint(JSON.parse(event.target.value)))
    };
    const { isLoading: LoadingPoints, data: dataPoints, isError: isErrorPoints, error: errorPoints, isFetching: fetchPoints, refetch: refetchPoints }
        = GET_REQUEST({ queryKey: "get_points", request: () => UseGetData('get_points'), enabled: true })
    const { isLoading: LoadingPaymentsMethod, data: dataPaymentsMethod, isError: isErrorPaymentsMethod }
        = GET_REQUEST({ queryKey: "get_payments_method", request: () => UseGetData('get_payments_method'), enabled: true })
    return { valueMethod, ChangeValueMethod, ChangeValuePoints, valuePoints, LoadingPoints, dataPoints, LoadingPaymentsMethod, dataPaymentsMethod }
}

export default HookPayPoints